import type { QueryClient } from "@tanstack/react-query";

/**
 * Tudo o que fica velho quando uma skill muda de estado (AB#85634).
 *
 * As telas de skill são quatro — administração do catálogo, detalhe da skill,
 * loja e configuração da instalação — e cada uma guarda a sua consulta. Até
 * aqui, publicar pela administração invalidava só a lista da administração: a
 * **loja continuava servindo o cache anterior**, e a skill recém-publicada só
 * aparecia depois de um recarregamento forçado do navegador.
 *
 * Uma lista só, chamada por todo mutador, em vez de cada tela lembrar das
 * outras — que é o que já tinha falhado. Invalidar demais custa uma requisição;
 * invalidar de menos custa alguém achando que a publicação não funcionou.
 *
 * As chaves são prefixos: o React Query casa por início, então
 * `["skills_storefront"]` alcança `["skills_storefront", escopo, produto]`.
 */
const CHAVES = [
  // Administração do catálogo
  ["skills_admin_catalog"],
  ["skill_admin_detail"],
  ["skill_admin_versions"],
  // Loja e instalações
  ["skills_storefront"],
  ["skills_installed"],
  ["skill_installed_detail"],
  ["skill_catalog_detail"],
  ["skill_versions"],
  ["skill_history"],
] as const;

export const invalidarSkills = (queryClient: QueryClient) => {
  for (const queryKey of CHAVES) {
    queryClient.invalidateQueries({ queryKey: [...queryKey] });
  }
};
